import React from "react";
import styled from "styled-components";

const Title = styled.div`
  border-bottom: 1px solid #ccc;
  max-width:500px
  margin-top:20px;
  margin-bottom:20px;
  color:#2b5979;
  font-size:22px;
  font-weight:bold;
`;
const SectionTitle = ({ id, children }) => (
  <Title id={id}>{children}</Title>
);
export default SectionTitle;
